const _             = require('underscore');
const Mn            = require('backbone.marionette');
const Helpers       = require('./helpers');
const TemplateCache = require('marionette.templatecache');

Mn.setRenderer(function (template, data, view) {
    data              = _.clone(data);
    data.isAdmin = Helpers.isAdmin;
    data.escape = Helpers.escape;
    data.trim = Helpers.trim;

    return TemplateCache.default.render.call(this, template, data, view);
});

module.exports = Mn;
